import React from 'react';
import { X } from 'lucide-react';

const PainPoint = ({ title, description }) => (
  <div className="pain-point">
    <div className="pain-point-icon">
      <X size={32} />
    </div>
    <div className="pain-point-content">
      <h3 className="pain-point-title">{title}</h3>
      <p className="pain-point-description">{description}</p>
    </div>
  </div>
);

const ProblemSection = () => (
  <section className="problem-section">
    <div className="section-container">
      <h2 className="section-headline">The Big-Box PEO Frustrations You're Living With</h2>
      <p className="section-supporting-text">
        If your HR partner feels like a ticketing system, it's not just annoying. It's costing you time, money, and trust internally.
      </p>
      <div className="pain-points">
        <PainPoint
          title="Bounced Between Call Centers"
          description="Average 3 to 5 transfers per issue before resolution. You explain the same issue repeatedly, then wait days for an answer that should take minutes."
        />
        <PainPoint
          title="Hidden Fees and Surprise Charges"
          description="Platform fees and add-ons show up with no warning, plus clients get a single renewal option with a take it or leave it approach."
        />
        <PainPoint
          title="Slow Response on Urgent Issues"
          description="Average 3 to 4 business day ticket resolution times. Payroll and benefits problems do not wait, but your 'support' does."
        />
        <PainPoint
          title="A New Rep Every 6 Months"
          description="High turnover means constantly re-explaining your business. Just when someone finally understands your business, they disappear and you start over."
        />
      </div>
    </div>
  </section>
);

export default ProblemSection;
